import { Box, Text } from '@factorialco/deprecated-design-system'
import moment, { Moment } from 'moment'

import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'

interface Props {
  endDate: Moment
  canEdit: boolean
  isEmployeeTerminated: boolean
}

const ALERT_DAYS_THRESHOLD = 28

const Details = ({ endDate, canEdit, isEmployeeTerminated }: Props) => {
  const now = moment()
  const hasExpired = endDate ? endDate.isBefore(now) : false
  const hasEndDateAlert =
    canEdit &&
    ((hasExpired && !isEmployeeTerminated) ||
      (!hasExpired && endDate.diff(now, 'days') < ALERT_DAYS_THRESHOLD))

  const alertMessage = hasExpired
    ? i18n.t('contract_versions.contract_information.end_date_alert_expired')
    : i18n.t('contract_versions.contract_information.end_date_alert_future')

  return (
    <Box alignItems="center" gap="s4" flexDirection="row">
      {!hasExpired && (
        <Text size="200" weight="normal" color="grey800">
          {endDate.fromNow()}
        </Text>
      )}
      {hasExpired && (
        <Text
          size="200"
          weight="normal"
          color={isEmployeeTerminated ? 'grey800' : 'radicalRed1200'}
        >
          {i18n.t('contract_versions.contract_information.end_date_expired')}
        </Text>
      )}
      {hasEndDateAlert && (
        <ContractTooltip
          information={alertMessage}
          icon="alert-circle-line"
          color="radicalRed1000"
        />
      )}
    </Box>
  )
}

export default Details
